import {useMutation} from "react-query";
import {RemoveRoleMemberCommand} from "../../models/user";
import roleMemberService from "../../services/RoleMemberService";

export default function useRemoveRoleMember() {
   return useMutation((request: RemoveRoleMemberCommand) => roleMemberService.remove(request));
}